module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-down-left-6.d71882f6.png";